/*
 * @Author: Teemo Ding
 * @Date: 2021-08-11 13:13:45
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-05-16 17:31:45
 * @FilePath: /unifyxp-v2-store-portal/src/pages/CustomerDatabaseConfig/CustomerDetails/Orders/index.tsx
 */

import { SizeFittingTable } from '@/src/components/Antd';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { ordersColumns } from '../config';
import css from '../css.module.less';
import { useSelector } from 'react-redux';
import { getBasicSetting } from 'src/constrains/GlobalProvider/slice';
import { isNumber, get } from 'lodash';
const Orders = ({
  orderActivities,
  totalOrderAmount,
  averageOrderAmount,
  lastOrderAmount,
  numOfOrders,
  currencyCode,
  timezoneInGMT,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const storeSettings = useSelector(getBasicSetting());
  const storeDecimal = get(storeSettings, 'decimalPosition');
  return (
    <div className={css.itemBlock}>
      <SectionWrapper
        titleClassName={css.titleContainer}
        containerClassName={`${css.ordersContainer} ${css.wrapperContainer}`}
        title={getI18n('general.sider.orders')}>
        <div className={css.ordersItems}>
          <div className={css.ordersItem}>
            {getI18n('customerList.orders.totalOrderNumber')}
            <span>{numOfOrders || '-'}</span>
          </div>
          <div className={css.ordersItem}>
            {getI18n('customerList.orders.totalOrderAmount')}
            <span>
              {isNumber(totalOrderAmount)
                ? `${currencyCode} ${totalOrderAmount.toFixed(storeDecimal)}`
                : '-'}
            </span>
          </div>
          <div className={css.ordersItem}>
            {getI18n('customerList.orders.averageOrderAmount')}
            <span>
              {isNumber(averageOrderAmount)
                ? `${currencyCode} ${averageOrderAmount.toFixed(storeDecimal)}`
                : '-'}
            </span>
          </div>
          <div className={css.ordersItem}>
            {getI18n('customerList.orders.lastOrderAmount')}
            <span>
              {isNumber(lastOrderAmount)
                ? `${currencyCode} ${lastOrderAmount.toFixed(storeDecimal)}`
                : '-'}
            </span>
          </div>
        </div>
        {!!(orderActivities || []).length && (
          <SizeFittingTable
            columns={ordersColumns(timezoneInGMT, { getI18n })}
            id='ordersTable'
            rowKey='orderId'
            pagination={false}
            dataSource={orderActivities}
          />
        )}
      </SectionWrapper>
    </div>
  );
};

export default Orders;
